@use '@/scss/underscore' as _;

.fieldDescription {
  font: var(--font-body-2);
  color: var(--color-text-secondary);
  margin: _.unit(1) 0 _.unit(2);
}
